/* eslint no-magic-numbers: 0, eqeqeq: 0, no-bitwise: 0, no-extra-parens: 0 */

export default function uidGenerator() {
   return 'rav_id_xxxxxxxxxxxx'.replace(/[xy]/g, function _repl(c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
   });
}
